import { injectGlobal } from 'styled-components'

import RobotoMonoThin from '../Assets/Fonts/RobotoMono-Thin.ttf'
import RobotoMonoLight from '../Assets/Fonts/RobotoMono-Light.ttf'
import RobotoMonoLightItalic from '../Assets/Fonts/RobotoMono-LightItalic.ttf'
import RobotoMonoRegular from '../Assets/Fonts/RobotoMono-Regular.ttf'
import RobotoMonoItalic from '../Assets/Fonts/RobotoMono-Italic.ttf'
import VT323Regular from '../Assets/Fonts/VT323-Regular.ttf'

import { palette } from './colors'
import { media } from './media'
const color = palette

injectGlobal`
  @font-face {
      font-family: RobotoMonoThin;
      src: url('${RobotoMonoThin}');
  }

  @font-face {
      font-family: RobotoMonoLight;
      src: url('${RobotoMonoLight}');
  }

  @font-face {
      font-family: RobotoMonoLightItalic;
      src: url('${RobotoMonoLightItalic}');
  }

  @font-face {
      font-family: RobotoMonoRegular;
      src: url('${RobotoMonoRegular}');
  }

  @font-face {
      font-family: RobotoMonoItalic;
      src: url('${RobotoMonoItalic}');
  }

  @font-face {
      font-family: VT323Regular;
      src: url('${VT323Regular}');
  }

  html {
    font-size: 62.5%;
    line-height: 62.5%;
  }

  @media screen and (min-width: 320px) {
    html {
      font-size: calc(62.5% + 6 * ((100vw - 320px) / 680));
      line-height: calc(62.5% + 6 * ((100vw - 320px) / 680));
    }
  }

  @media screen and (min-width: 1000px) {
    html {
      font-size: 125%;
      line-height: 125%;
    }
  }

  body {
    background-color: ${color.base};
    color: ${color.text};
    font-family: RobotoMonoLight, monospace, sans-serif;
    margin: 0;
  }

  h1, h2, h3,
  h4, h5, h6 {
    font-family: RobotoMonoThin, monospace, sans-serif;
    font-weight: 400;
    line-height: inherit;
    color: ${color.lightone};
  }

  h1 {
    font-size: 2.4em;
    line-height: 1.5em;
  }

  p {
    font-family: RobotoMonoLight, monospace, sans-serif;
    font-weight: 400;
    font-size: 1.2em;
    line-height: 2em;
  }

  a, a:visited {
    font-family: RobotoMonoRegular, monospace, sans-serif;
    font-weight: normal;
    font-size: 1.2em;
    text-decoration: line-through;
    color: ${color.text};
    transition: text-decoration 2s;
  }

  a:hover {
    text-decoration: overline;
  }

  ${media.desktop`
    h1 { font-size: 2em; }
    p { font-size: 1em; }
  `}
`



// WEBPACK FOOTER //
// ./src/Styles/index.js